module.exports = __webpack_public_path__ + "img/潘臻琦.af44433b.jpg";